import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';

import { UserService } from './user.service';
import { DemoUserService } from './demo-user.service';

export function userServiceFactory(http: HttpClient): UserService {
  return environment.demoMode ? new DemoUserService(http) : new UserService(http);
}

export const userServiceProvider = {
  provide: UserService,
  useFactory: userServiceFactory,
  deps: [HttpClient]
};
